// extracted by mini-css-extract-plugin
module.exports = {"qrcode":"RThyTqG_","title":"Wz_xEvXg","desc":"rxFW81nU"};